import { User } from "@auth0/auth0-react"
import { AUTH0_ROLE_CUSTOM_CLAIM } from '../env'

export const getUserRole = function (user?: User) {
    if (user && AUTH0_ROLE_CUSTOM_CLAIM in user) {
        return user[AUTH0_ROLE_CUSTOM_CLAIM][0];
    } else {
        return '';
    }
}